import {Component, Input, OnInit} from '@angular/core';
import {NavService} from '../../../services/nav.service';
import {environment} from '../../../../environments/environment';
import {UserService} from '../../../services/user.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    @Input() backRoute: any = null;
    @Input() colorStyle: string;
    @Input() backIcon = true;
    @Input() menuIcon = true;
    @Input() middleIcon = true;
    @Input() middleIconLink = true;
    @Input() middleIconSize = 'normal';
    @Input() middleIconMobile = true;
    @Input() socialIcons = false;
    @Input() socialIcon = false;
    @Input() leaderboardIcon = false;
    @Input() background = true;
    @Input() backIconWork = true;
    @Input() headerTitle = null;
    @Input() hide930 = false;

    theme = 'default';

    constructor(
        private nav: NavService,
        public userService: UserService,
    ) {
    }

    ngOnInit() {
        this.theme = environment.theme;
    }

    goHome() {
        this.nav.navigateHome();
    }

    goBack() {
        if (this.backIconWork) {
            if (this.backRoute !== null) {
                this.nav.navigateBack(this.backRoute);
            } else {
                this.nav.back();
            }
        }
    }

    goToLeaderboard() {
        this.nav.navigate(['/leaderboard']);
    }

    goToSocial() {
        this.nav.navigate(['/social']);
    }

    getActionLogOut() {
        this.nav.logout();
    }
}
